import dayjs from 'dayjs'

import { getApiHost } from '../../../core/infraestructure/apiClient'
import {
  getDefaultSelectedLanguage,
  getUserName,
  getUserRoles,
} from '../../../core/services/storage.service'
import { AdobeDataLayer, sDataLayer } from './datalaLayer.model'

const digitalDataConf = {
  dataLayerName: 'digitalData',
  s_LayerName: 's'
}

const digitalData: AdobeDataLayer = {
  page: {
    category: {
      siteName: "Carriers' Liability Online",
      applicationName: `${getDefaultSelectedLanguage()}.calculator.clo`,
      productPage: "Carriers' Liability Online",
      pageCategory: 'calculator',
    },

    pageInfo: {
      country: 'ch',
      language: getDefaultSelectedLanguage(),
      server: getApiHost(),
      previousPage: {
        pageName: 'Home - Carriers Liability Online'
      },
      pageName: '/calculator/vehicles',
    },
  },
  product: {
    productInfo: {
      productName: "Carriers' Liability Online",
    },
  },
  user: {
    profile: {
      interactionInfo: {
        hour: `${dayjs().hour()}:${dayjs().minute()}`,
        day: `${dayjs().year()}.${dayjs().month() + 1}.${dayjs().date()}`,
        dayType: `${dayjs().day()}`,
        timestamp: dayjs().valueOf(),
      },
      profileInfo: {
        customerID: getUserName(),
        loginState: "not_logged"
      },
    },
  },
}

const sProductLayer: sDataLayer = {
  products: ''
}

const { dataLayerName, s_LayerName } = digitalDataConf

window[dataLayerName] = window[dataLayerName] || digitalData

window[s_LayerName] = window[s_LayerName] || sProductLayer

export const dataLayer: AdobeDataLayer = window[dataLayerName]

export const s_Layer: sDataLayer = window[s_LayerName]

export function useAdobeSatellite(callback: (adobeSatellite) => void) {
  if (withAdobeSatellite(callback)) {
    return;
  }
  const intervalId = setInterval(
    () => withAdobeSatellite(adobeSatellite => {
      clearInterval(intervalId);
      callback(adobeSatellite);
    }),
    250
  );
}

function withAdobeSatellite(callback: (adobeSatellite) => void) {
  const adobeSatellite = window['_satellite'];
  console.log('adobeSatellite', adobeSatellite);
  if (adobeSatellite) {
    callback(adobeSatellite);
  }
  return !!adobeSatellite;
}
